import { getPaymentLinkHeaders } from "../../utils/paymentLinkHeaders";

const BASE_URL = process.env.REACT_APP_API_URL || "";
const PREFIX = "/api/direct-debit/public/bind";

async function request(path, options = {}) {
  const response = await fetch(`${BASE_URL}${PREFIX}${path}`, {
    ...options,
    headers: {
      ...getPaymentLinkHeaders(),
      ...(options.headers || {}),
    },
  });

  const json = await response.json().catch(() => ({}));

  if (!response.ok || json.success === false) {
    throw new Error(json.message || "Request failed");
  }

  return json.data;
}

export const directDebitApi = {
  getState(publicToken) {
    return request(`/${encodeURIComponent(publicToken)}`, { method: "GET" });
  },

  submitCard(publicToken, cardNumber, expiry) {
    return request(`/${encodeURIComponent(publicToken)}/card`, {
      method: "POST",
      body: JSON.stringify({ card_number: cardNumber, expiry }),
    });
  },

  verifyOtp(publicToken, otp) {
    return request(`/${encodeURIComponent(publicToken)}/otp`, {
      method: "POST",
      body: JSON.stringify({ otp }),
    });
  },

  resendOtp(publicToken) {
    return request(`/${encodeURIComponent(publicToken)}/otp/resend`, {
      method: "POST",
      body: JSON.stringify({}),
    });
  },

  setLimit(publicToken, dailyLimit) {
    return request(`/${encodeURIComponent(publicToken)}/limit`, {
      method: "POST",
      body: JSON.stringify({ daily_limit: dailyLimit, currency: "IDR" }),
    });
  },

  selectBank(publicToken, bankCode) {
    return request(`/${encodeURIComponent(publicToken)}/bank`, {
      method: "POST",
      body: JSON.stringify({ bank_code: bankCode }),
    });
  },
};
